/* The chart card's reserved plot box — see `ChartCardShell.tsx`.
 *
 * ONE class for every chart card in the app, with the height arriving as `--chart-card-reserve`
 * from the caller. Two surfaces reserve two heights (Trendy's 112px plot, the Ankiety strip's 96px)
 * and everything else about the box is identical, so a second class would have been the same four
 * declarations differing by a token — the near-duplicate the styling rule exists to prevent.
 *
 * There is no fallback on the custom property, deliberately and for `scrollbar.module.css`'s own
 * reason: a default written here is a declaration a caller's own could lose to depending on which
 * chunk the build emitted last. A caller that forgets it gets a zero-height box, which is loud. */

.reserve {
  display: grid;
  place-items: center;
  block-size: var(--chart-card-reserve);
}

/* A plot's shape is a line, so its skeleton is one bar across the box the chart will occupy. */
.skelPlot {
  width: 100%;
  height: var(--space-10);
}
